import React from 'react'
import cat1 from "../assets/images/cat1.png"
import cat2 from "../assets/images/cat2.png"
import cat3 from "../assets/images/cat3.png"
import cat4 from "../assets/images/cat4.png"
import cat5 from "../assets/images/cat5.png"
import cat6 from "../assets/images/cat6.png"
import cat7 from "../assets/images/cat7.png"
import cat8 from "../assets/images/cat8.png"
import catImage from "../assets/images/partitionImage.png"
import glow from "../assets/images/Ellipse4.png"

const Cats = () => {
  return (
    <div className="catsContainer">

      <div className='catsBorderContainer'>
      <div className="catsMainContainer">
         <img src={catImage} alt='cat image' className='categoryImage' loading="lazy"/>
      <div className="catsContent">
        <div className="catsTitle">
        <h1  data-aos="fade-up"
     data-aos-duration="2000">کنار هم، کامـــل‌تریم</h1>
        <p  data-aos="fade-up"
     data-aos-duration="2000">یخچال فریزر پاکشوما | سری Twin Peaks</p>
        </div>
        <div className="catsList">
          <img src={cat1} alt="cat1" loading="lazy"/>
          <img src={cat2} alt="cat2" loading="lazy"/>
          <img src={cat3} alt="cat3" loading="lazy"/>
          <img src={cat4} alt="cat4" loading="lazy"/>
          <img src={cat5} alt="cat5" loading="lazy"/>
          <img src={cat6} alt="cat6" loading="lazy"/>
          <img src={cat7} alt="cat7" loading="lazy"/>
          <img src={cat8} alt="cat8" loading="lazy"/>
        </div>
      </div>
      </div>
      </div>
    </div>
  )
}

export default Cats